export const BADGE_HEIGHT = 20;

export const ICON_SIZE = 12;
